import React from 'react';
type LogoProps = {
  /** 'ink' for light backgrounds, 'paper' for dark backgrounds. */
  tone?: 'ink' | 'paper';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};
const sizes = {
  sm: {
    mark: 24,
    text: 'text-[18px]',
    gap: 'gap-2.5'
  },
  md: {
    mark: 28,
    text: 'text-[22px]',
    gap: 'gap-3'
  },
  lg: {
    mark: 34,
    text: 'text-[27px]',
    gap: 'gap-3.5'
  }
};

/**
 * NexLaw identity: a compact monogram where the "N" diagonal breaks out of the
 * frame as a forward stroke, paired with a tight-tracked wordmark.
 */
export function Logo({
  tone = 'ink',
  size = 'sm',
  className = ''
}: LogoProps) {
  const {
    mark,
    text,
    gap
  } = sizes[size];
  const plate = tone === 'ink' ? '#111315' : '#FAF8F5';
  const cut = tone === 'ink' ? '#FAF8F5' : '#111315';
  const accent = tone === 'ink' ? '#1B3A57' : '#FAF8F5';
  const wordmark = tone === 'ink' ? 'text-ink' : 'text-paper';
  return <span className={`inline-flex items-center ${gap} ${className}`} data-id="element-63" data-mp="32k0hadl961c1">
      <svg width={mark} height={mark} viewBox="0 0 32 32" fill="none" aria-hidden="true" className="shrink-0" data-id="element-64" data-mp="32lbjwa2yp31k">
        <rect width="32" height="32" rx="8" fill={plate} data-id="element-65" data-mp="19wyhz6yqltk4" />
        {/* left stem */}
        <rect x="9" y="9" width="2.4" height="14" rx="1.2" fill={cut} data-id="element-66" data-mp="1nw7o1dt8b7ad" />
        {/* right stem */}
        <rect x="20.6" y="9" width="2.4" height="14" rx="1.2" fill={cut} data-id="element-67" data-mp="1jtl0vq7i6aji" />
        {/* diagonal — the forward stroke */}
        <path d="M10.2 9.6 L21.8 22.4" stroke={cut} strokeWidth="2.4" strokeLinecap="round" data-id="element-68" data-mp="1xsu8i1hn7wbv" />
      </svg>

      <span className={`font-display ${text} font-medium leading-none tracking-tightest ${wordmark}`} data-id="element-69" data-mp="27jp3pvcva69g">
        NexLaw
        <span style={{
        color: accent
      }} data-id="element-70" data-mp="22kc9uqnkvyxd">.</span>
      </span>
    </span>;
}